import "./SecureYourTalent.module.css";
import Header from "@/reusable_sections/Header";
import GetYourFreeEstimate from "./sections/GetYourFreeEstimate";
import CommonInquiries from "./sections/CommonInquiries";
import GamingSocialFooter from "@/reusable_sections/Footer";
export default function SecureYourTalentPage() {
  return <div>
      <Header />
      <GetYourFreeEstimate />
      <CommonInquiries />
      <GamingSocialFooter />
    </div>;
}